// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B5AB","delete":"styles_delete__gZfDu","update":"styles_update__1juny","add":"styles_add__2yAAe"};